import React from 'react';

// Define a mapping for icons
export const iconMapping = {
    positions: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/December_9_2024/etf-matrix-chart.jpg',
    smalab: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/index-app.png',
    blacklist: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/blacklist-checkmark.png',
    screener: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/screens-31.webp',
    formBuilder: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/December_9_2024/360-600.jpg',
    portfolios: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/December_9_2024/stock-app-square-512.JPG',
    performanceComparison: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/comparison-v55.jpg',
    signals: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/signal-simple.png',
    portfolioBuilder: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/Lastest1282024/ares-app-icon.png',
    settings: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/settings.png',
    prospects: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/prospects.png',
    superUser: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/super-user-alt-1.png',
    files: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/files-alt-1.png',
    touchpoints: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/pulsa-app-icon.png',
    iq: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/iq-icon-2.png',
    resources: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/learning-app-icon.png',
    portfolioPath: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/portfolio-path-app.jpg',
    stockLogo: 'https://storage.googleapis.com/finiat-web-static-resources/homescreenGraphics/company-logo-screen-to-back.avif',
    xray: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/xray-black.png',
    exchange: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/December_9_2024/exchange-pattern.avif',
};




// Define all available apps in one common array
export const allApps = [
    { label: 'Portfolios', iconUrl: iconMapping.portfolios, key: 'portfolios', path: '/portfolios' },
    { label: 'Signals', iconUrl: iconMapping.signals, key: 'signals', path: '/signals' },
    { label: 'Paths', iconUrl: iconMapping.portfolioPath, key: 'portfolioPath', path: '/portfolios/paths' },

    { label: 'ETF Matrix', iconUrl: iconMapping.positions, key: 'positions', path: '/etfs/matrix' },
    { label: 'Comparison', iconUrl: iconMapping.performanceComparison, key: 'performanceComparison', path: '/performance/comparison' },

    { label: 'Screener', iconUrl: iconMapping.screener, key: 'screener', path: '/screener' },
    { label: 'Blacklist', iconUrl: iconMapping.blacklist, key: 'blacklist', path: '/widgets/blacklist' },

    { label: 'Builder', iconUrl: iconMapping.portfolioBuilder, key: 'portfolioBuilder', path: '/builders/landing' },
    { label: 'i-Index', iconUrl: iconMapping.smalab, key: 'smalab', path: '/builders/sma' },
    { label: 'Align 360', iconUrl: iconMapping.formBuilder, key: 'formBuilder', path: '/builders/model' },
    { label: 'XRay', iconUrl: iconMapping.xray, key: 'xray', path: '/beta/xray' },
    { label: "Exchange", iconUrl: iconMapping.exchange, key: 'exchange', path: '/portfolios/exchange' },

    {label: "SuperUser", iconUrl: iconMapping.superUser, key: 'superuser', path: '/superuser'}
];



export const filterUserAppsIntoCategories = (userAppKeys) =>
    [...allApps].filter(app => userAppKeys.includes(app.key));



// Function to filter apps based on user's keys
export const filterAppsForUser = (userAppKeys, prefix='') => {
    let filteredApps = allApps.filter(app => userAppKeys.includes(app.key));
    // filteredApps.sort((a, b) => userAppKeys.indexOf(a.key) - userAppKeys.indexOf(b.key));

    return [
        ...filteredApps
    ].map(x=>({...x, path: prefix+x.path}
    ));
};
